import i18n from '../i18n';

const formatMoney = {
  methods: {
    formatMoney(amount) {
      if (Number.isNaN(amount)) return '';
      let a = '';
      let checkAmount = amount;
      if (Number(amount) < 0) {
        a = '(';
        checkAmount = Math.abs(amount);
      }
      a = `${a}${new Intl.NumberFormat(`${i18n.locale}-CA`, { style: 'currency', currency: 'CAD' }).format(checkAmount)}`;

      if (Number(amount) < 0) {
        a = `${a})`;
      }
      return a;
    },
  },
};

export default formatMoney;



// WEBPACK FOOTER //
// ./src/mixins/formatMoney.js